/**
 * Domain types for DECOY branding system
 */

export type DomainType = 'vrp' | 'fleet' | 'enterprise';

export interface DomainTheme {
  name: string;
  description: string;
  logo: string;
  colors: {
    primary: string;
    accent: string;
    secondary: string;
    background?: string;
    surface?: string;
  };
}

export interface DomainConfig {
  vrp: DomainTheme;
  fleet: DomainTheme;
  enterprise: DomainTheme;
}

export interface DomainThemeContextType {
  currentDomain: DomainType;
  setDomain: (domain: DomainType) => void;
  getDomainTheme: (domain?: DomainType) => DomainTheme;
  availableDomains: DomainType[];
  // Dark mode functionality
  darkMode: boolean;
  setDarkMode: (enabled: boolean) => void;
  toggleDarkMode: () => void;
}

export const DOMAIN_THEMES: DomainConfig = {
  vrp: {
    name: 'VRP Optimization',
    description: 'Vehicle Routing Problem solver and route optimization',
    logo: 'decoy-logo-vrp.png',
    colors: {
      primary: '#2D5A4A',    // Dark green
      accent: '#3ECF8E',     // Supabase green  
      secondary: '#1F2937',  // Dark gray
      background: '#F3F4F6',
      surface: '#FFFFFF',
    }
  },
  fleet: {
    name: 'Fleet Management',
    description: 'Comprehensive fleet and vehicle management system',
    logo: 'decoy-logo-fleet.png', 
    colors: {
      primary: '#3ECF8E',    // Bright green (Supabase primary)
      accent: '#10B981',     // Success green
      secondary: '#1F2937',  // Dark gray
      background: '#F3F4F6',
      surface: '#FFFFFF',
    }
  },
  enterprise: {
    name: 'DECOY Enterprises',
    description: 'Corporate solutions and enterprise management',
    logo: 'decoy-logo-enterprise.png',
    colors: {
      primary: '#4A90A4',    // Teal
      accent: '#3B82F6',     // Blue accent
      secondary: '#1F2937',  // Dark gray
      background: '#F3F4F6', 
      surface: '#FFFFFF',
    }
  }
};

// Local storage key for domain preference
export const DOMAIN_STORAGE_KEY = 'decoy-preferred-domain';

// Default domain
export const DEFAULT_DOMAIN: DomainType = 'fleet';